import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InterventionList from './InterventionList';
import Intervention from './InterventionDetails';

function InterventionsIndex() {
  return (
    <>
      <Routes>
        <Route path="/" element={<InterventionList />} />
        <Route path="details/:id" element={<Intervention />} />
        <Route path="details/create" element={<Intervention />} />
      </Routes>
    </>
  );
}

export default InterventionsIndex;
